<script setup>

</script>

<template>
  <div id="system">系统配置</div>
</template>

<style lang="scss" scoped>
#system {
  height: 100%;
}
</style>
